module.exports = __webpack_public_path__ + "img/logo_white_yili.c2f6e45.png";